import type { PropsWithChildren } from 'react';

export type ActionsBarProps = PropsWithChildren;

export const ActionsBar = ({ children }: ActionsBarProps) => (
  <div className="sticky bottom-0 overflow-hidden shadow-sm">{children}</div>
);
